import * as React from 'react';
import {DefaultButton, Dropdown, PrimaryButton, Toggle} from '@fluentui/react';
import { Panel } from '@fluentui/react';
import {useContext, useEffect, useState} from "react";
import {Stack} from "@fluentui/react";
import AuthContext from "../../Services/AuthContext";

function AddChecklist(props) {
    const [user] = useContext(AuthContext);
    const [item, setItem] = useState(null);
    const [items, setItems] = useState([]);
    const [generate, setGenerate] = useState(true);

    useEffect(() => {

    }, [props.add])

    const _submit = (e) => {
        e.preventDefault();
        if (generate) {
            fetch(`/api/project/${props.add}/checklist`, {
                method: 'PUT',
                headers: {
                    'Authorization': 'Bearer ' + user.token
                }
            }).then(res => res.json())
                .then(json => { props.onSuccess(json); props.dismissPanel(); })
                .catch(err => { console.log(err) })
        }
        else {
            const data = {checklist_item_id: item.key};
            fetch(`/api/project/${props.add}/checklist`, {
                method: 'POST',
                body: JSON.stringify(data),
                headers: {
                    'Authorization': 'Bearer ' + user.token
                }
            }).then(res => res.json())
                .then(json => { props.onSuccess(json); props.dismissPanel(); })
                .catch(err => { console.log(err) })
        }

    }

    const footer = React.useCallback(() => (<Stack horizontal horizontalAlign='space-between'>
        <PrimaryButton type='submit' form='AddChecklistItem'>Dodaj</PrimaryButton>
        <DefaultButton onClick={props.dismissPanel}>Anuluj</DefaultButton>
    </Stack>), [props.dismissPanel]);


    useEffect(() => {
        const abortController = new AbortController();
        if (props.add) {
            setItem(null);
            async function fetchVentures() {
                await fetch(`/api/project/${props.add}/checklist/free`, {
                    method: 'GET',
                    signal: abortController.signal,
                    headers: {
                        'Authorization': 'Bearer ' + user.token
                    }
                }).then(res => res.json())
                    .then(data => {
                        setItems(data.map((checklist) => {
                            return {key: checklist.id, text: checklist.item};
                        }))
                    })
                    .catch(err => {
                        console.log(err)
                    })
            }
            fetchVentures();
        }
        return () => abortController.abort();
    }, [props.add, user.token])

    var optionalProps = {};
    if (generate) optionalProps.defaultChecked = true;

    return (
        <Panel
            isOpen={props.add}
            onDismiss={props.dismissPanel}
            headerText="Dodaj Punkt Kontrolny"
            closeButtonAriaLabel="Close"
            onRenderFooterContent={footer}
            isFooterAtBottom={true}
        >
            <form onSubmit={_submit} id='AddChecklistItem'>
                <Toggle label="Generuj Domyślne" {...optionalProps} onText="Tak" offText="Nie" onChange={(e, checked) => setGenerate(checked)} />
                <Dropdown
                    disabled={generate}
                    label="Punkt Kontrolny"
                    selectedKey={item ? item.key : undefined}
                    onChange={(e, selected) => setItem(selected)}
                    placeholder="Wybierz z listy"
                    options={items}
                />
            </form>
        </Panel>
    )
}

export default AddChecklist;